import { Typography } from 'gu-ui-kit'
import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export const AliasCell = ({ financial_profile_type_alias }) => {
  const { t } = useTranslation()
  return (
    <Typography component={'span'} variant={'Body-15'} color={'Label-Fifth'}>
      {t(
        `referral::referral_links_create.table.options.${financial_profile_type_alias}`,
      )}
    </Typography>
  )
}

AliasCell.propTypes = {
  financial_profile_type_alias: PropTypes.string,
}
